var _path, _path2, _path3, _path4;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgBorrowUnitsQuickServiceIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14 9.5C15.5188 9.5 16.75 8.26878 16.75 6.75C16.75 5.23122 15.5188 4 14 4C12.4812 4 11.25 5.23122 11.25 6.75C11.25 8.26878 12.4812 9.5 14 9.5Z",
    stroke: "currentColor",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M12.5317 4.42438C12.113 3.44013 11.1371 2.75 10 2.75C8.48122 2.75 7.25 3.98122 7.25 5.5C7.25 7.01878 8.48122 8.25 10 8.25C10.5399 8.25 11.0435 8.09441 11.4683 7.82562",
    stroke: "currentColor",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M3.75 20.2499H4.78125C4.78125 20.2499 8.49035 21.5047 10.9688 21.2468C13.6138 20.9716 17.902 18.4298 19.5626 17.3902C19.9965 17.1185 20.25 16.6424 20.25 16.1306C20.25 15.099 19.249 14.3638 18.2647 14.6724L11 16.9499",
    stroke: "currentColor",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M3.75 14.4375L7.01474 13.2689C7.96969 12.9271 8.98752 12.7968 9.99777 12.8872L14.1456 13.2584C14.4589 13.2865 14.6688 13.5933 14.5814 13.8954L14.5673 13.944C14.1977 15.2216 13.2173 16.232 11.9514 16.6398L11 16.9463",
    stroke: "currentColor",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBorrowUnitsQuickServiceIcon);
export default __webpack_public_path__ + "static/media/borrow-units-quick-service-icon.b4e08dc7d325805aea8588916628b9c0.svg";
export { ForwardRef as ReactComponent };